import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';

import { FilesAndSuggestionsPluginService } from './filesandsuggestions-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { EditFileAndSuggestionMenuComponent } from '../../menus/index';

@Component({
    selector: 'fileandsuggestion-edit-suggestion',
    templateUrl: './fileandsuggestion-edit-suggestion.component.html',
    standalone: false
})
export class FileAndSuggestionEditSuggestionPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  assetId: string;
  public plugin: any;
  public suggestedAssetId: number;
  public suggestionsAssets: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  public processing = false;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  @ViewChild('deleteFileConfirm', { static: true })
  deleteFileConfirm: ConfirmComponent;

  public menuComponent = EditFileAndSuggestionMenuComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: FilesAndSuggestionsPluginService,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      const assetId = params['assetId'];
      if (assetId == null) this.goToBack();

      this.assetId = assetId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    this.service.editSuggestion(this.inspectionId, this.pointId, this.pluginId, this.assetId, '').subscribe((data) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 2:
        this.openDeleteFileConfirm();
        break;
      default:
    }
  }

  ngOnInit() {
    this.initRoute();
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  openDeleteFileConfirm() {
    this.deleteFileConfirm.open();
  }

  gotoPrevious() {
    this.suggestedAssetId = this.suggestedAssetId - 1;
    if (this.suggestedAssetId === 0) {
      this.suggestedAssetId = this.suggestionsAssets.length;
    }
  }

  gotoNext() {
    this.suggestedAssetId = this.suggestedAssetId + 1;
    if (this.suggestedAssetId === this.suggestionsAssets.length + 1) this.suggestedAssetId = 1;
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      const suggestions = this.plugin.config.Suggestions;
      // this.suggestionsAssets = [1,2,3,4];
      this.suggestedAssetId = this.suggestionsAssets[0];
      this.cdf.detectChanges();
    });
  }

  deleteFile(e: any) {
    this.service.deleteFile(this.inspectionId, this.pointId, this.pluginId, this.assetId).subscribe((data) => {
      this.service.deleteLocalComment(this.assetId);
      this.goToBack();
    });
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
